import util from '../util';

export const FEED = 'FEED';
export const FEEDS = 'FEEDS';
export const FEED_CREATE = 'FEED_CREATE';
export const FEED_UPDATE = 'FEED_UPDATE';
export const RESET_FEED = 'RESET_FEED';
export const DELETE_FEED = 'DELETE_FEED';

export const FEEDS_REQUEST = util.requestType(FEEDS);
export const FEEDS_SUCCESS = util.successType(FEEDS);
export const FEEDS_FAILURE = util.failureType(FEEDS);

export const FEED_REQUEST = util.requestType(FEED);
export const FEED_SUCCESS = util.successType(FEED);
export const FEED_FAILURE = util.failureType(FEED);

export const CREATE_FEED_REQUEST = util.requestType(FEED_CREATE);
export const CREATE_FEED_SUCCESS = util.successType(FEED_CREATE);
export const CREATE_FEED_FAILURE = util.failureType(FEED_CREATE);

export const UPDATE_FEED_REQUEST = util.requestType(FEED_UPDATE);
export const UPDATE_FEED_SUCCESS = util.successType(FEED_UPDATE);
export const UPDATE_FEED_FAILURE = util.failureType(FEED_UPDATE);

export const DELETE_FEED_REQUEST = util.requestType(DELETE_FEED);
export const DELETE_FEED_SUCCESS = util.successType(DELETE_FEED);
export const DELETE_FEED_FAILURE = util.failureType(DELETE_FEED);
